export default {
  readyToJoin: 'Ready to join?',
  join: 'Join!',
  waitingForCandidate: 'Waiting for candidate',
  alreadyJoinedHeader: 'Interview already joined',
  alreadyJoinedBy: 'This interview is currently joined by',
  okay: 'Okay',
  ratingDisabledTooltip: 'Rating interview is only available upto 24 hours after the interview duration.',
  testSpeaker: 'Test Audio Output',
  yourDevices: 'Select the device you will use to listen to the interview',
  done: 'Done',
  checkYourDevice: 'Test Audio Output',
  guestMeet: {
    readyToJoin: `You're almost there!`,
    enterInfoToJoin:
      'Enter your name, email, and verification code to access the interview. You can find your verification code in the original interview invitation email you received to access this interview.',
    name: 'Name',
    namePlaceholder: 'Enter your name',
    nameRequired: 'Your name is required',
    email: 'Email',
    emailPlaceholder: 'Select an email address',
    customEmailPlaceholder: 'Enter an email address',
    emailRequired: 'An Email is required',
    invalidEmail: 'Invalid email address',
    codeRequired: 'Code is required',
    code: 'Verification Code',
    codePlaceholder: 'Enter the verification code you were given',
    join: 'Join',
    hintMessageBeforeJoin:
      'In preparation for the interview, please make sure you are using the headphone or the device that you will use for the event.',
    joinAsLabel: 'You are logged in as {{userName}}.',
    joinMessage: 'You can now join the interview',
    joinMessagePreInterview: 'This interview will begin at {{time}}.',
    joinMessagePreInterviewOnAnotherDay: 'This interview will begin at {{day}}, {{time}}.',
    joinMessagePastInterview: 'This interview has been completed',
    interviewCancelled: 'The candidate has canceled their interview for {{position}} at {{location}} scheduled at {{time}}.',
    invalidCode: 'Invalid Code',
    leaveCall: 'Leave Interview',
    sessionModalTitle: 'Notice',
    sessionModalText: `You've successfully logged in as a co-interviewer.`,
    errorMessage: 'You could not successfully log in due to an error. Please try connecting again.',
    playAudio: 'Play Audio',
  },
  errorCode: {
    '1005': 'You cannot join the interview before its start time.',
    '1006': `You cannot join the interview after it's ended.`,
  },
  collaboratorFeatureNotAvailable: `Our co-interviewer feature is currently unavailable.`,
  timeEndingAlert: {
    giveAssessment: "Don't Forget to Assess The Candidate!",
    interviewTimeEnd: 'This interview will end soon.',
    timeRemaining: "This interview will end soon, so make sure to assess the candidate beforehand if you haven't already.\n",
    interviewEndAfter: 'This interview will automatically end in',
    okay: 'I understand',
  },
  candidateInformation: 'Candidate Information',
  others: 'Other',
};
